export default {
	root: {},
}
